import { Routes } from '@angular/router';
import { Permissions } from 'src/app/core/common';
import { RoutesConstants } from 'src/app/shared/common';
import { RouterComponent } from 'src/app/shared/component/router/router.component';
import { PermissionGuard } from 'src/app/shared/guard/permission-guard';

export const UPLOADS_ROUTES: Routes = [
  {
    path: RoutesConstants.UPLOAD_TEACHERS_FILES,
    component: RouterComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./upload-teachers-file/pages/upload-teachers/upload-teachers.component').then(
            (x) => x.UploadTeachersComponent
          ),
        data: {
          permissions: [Permissions.UploadDate_Teacher],
        },
      },
      {
        path: RoutesConstants.SHOW_TEACHERS_FILES,
        loadComponent: () =>
          import('./upload-teachers-file/pages/teachers-table/teachers-table.component').then(
            (x) => x.TeachersTableComponent
          ),
        data: {
          breadcrumb: {
            label: 'UPLOAD_TEACHERS_FILES',
            icon: 'cloud_upload',
          },
          permissions: [Permissions.UploadDate_Teacher],
        },
      },
    ],
  },
  // {
  //     path: RoutesConstants.UPLOAD_STUDENTS_FILES,
  //     component: RouterComponent,
  //     children: [
  //         {
  //             path: '',
  //             loadComponent: () => import('./upload-students-file/pages/upload-students/upload-students.component').then((x) => x.UploadStudentsComponent),
  //             data: {
  //                 permissions: [Permissions.UploadDate_Student]
  //             },
  //         },
  //         {
  //             path: RoutesConstants.SHOW_STUDENTS_FILES,
  //             loadComponent: () => import('./upload-students-file/pages/students-table/students-table.component').then((x) => x.StudentsTableComponent),
  //             data: {
  //                 permissions: [Permissions.UploadDate_Student]
  //             },
  //         },
  //     ],
  // },
  // {
  //     path: RoutesConstants.UPLOAD_STUDENTS_PLANS_FILES,
  //     component: RouterComponent,
  //     children: [
  //         {
  //             path: '',
  //             loadComponent: () => import('./upload-students-plans-file/pages/upload-students-plans/upload-students-plans.component').then((x) => x.UploadStudentsPlansComponent),
  //             data: {
  //                 permissions: [Permissions.UploadDate_Student_Plan]
  //             },
  //         },
  //         {
  //             path: RoutesConstants.SHOW_STUDENTS_PLANS_FILES,
  //             loadComponent: () => import('./upload-students-plans-file/pages/students-plans-table/students-plans-table.component').then((x) => x.StudentsPlansTableComponent),
  //             data: {
  //                 permissions: [Permissions.UploadDate_Student_Plan]
  //             },
  //         },
  //     ],

  // },
  // {
  //     path: RoutesConstants.UPLOAD_UPDATE_STUDENTS_FILES,
  //     component: RouterComponent,
  //     children: [
  //         {
  //             path: '',
  //             loadComponent: () => import('./upload-update-students-file/pages/upload-update-students/upload-update-students.component').then((x) => x.UploadUpdateStudentsComponent),
  //             data: {
  //                 permissions: [Permissions.UploadDate_Update_Student]
  //             },
  //         },
  //         {
  //             path: RoutesConstants.SHOW_UPDATE_STUDENTS_FILES,
  //             loadComponent: () => import('./upload-update-students-file/pages/students-update-table/students-update-table.component').then((x) => x.StudentsUpdateTableComponent),
  //             data: {
  //                 permissions: [Permissions.UploadDate_Update_Student]
  //             },
  //         }
  //     ],

  // },
];

for (const route of UPLOADS_ROUTES) {
  route.canActivate = [PermissionGuard];
}
